import { icons } from "./NavbarService";

export type MenuItemType = {
  route: string;
  id: keyof typeof icons;
  translationId: string;
  dropdown?: boolean;
  toggleId?: string;
  suffix?: string;
};

export type UserType = {
  firstName?: string;
  lastName?: string;
  email: string;
};

const MENU_ITEMS: MenuItemType[] = [
  {
    route: "map",
    id: "map",
    translationId: "navbar.map",
  },
  {
    route: "parcels",
    id: "parcels",
    translationId: "navbar.parcels",
  },
  {
    route: "parcels-v2",
    id: "parcelsV2",
    translationId: "navbar.parcels",
    suffix: " V2",
  },
  {
    route: "precision-farming",
    id: "precision",
    translationId: "navbar.precision",
  },
  {
    route: "telematics",
    id: "telematics",
    translationId: "navbar.telematics",
  },
  {
    route: "sensors",
    id: "sensors",
    translationId: "navbar.sensors",
    dropdown: true,
  },
  {
    route: "irrigation/areas",
    id: "irrigation",
    translationId: "navbar.irrigation",
    dropdown: true,
  },
  {
    route: "notifications",
    id: "notifications",
    translationId: "navbar.notifications",
    dropdown: true,
  },
  {
    route: "actions",
    id: "actions",
    translationId: "navbar.activities",
    dropdown: true,
  },
  {
    route: "actions-v2",
    id: "actionsV2",
    translationId: "navbar.activities",
    dropdown: true,
  },
  {
    route: "stores",
    id: "stores",
    translationId: "navbar.stores",
    dropdown: true,
  },
  {
    route: "reports",
    id: "reports",
    translationId: "navbar.reports",
    dropdown: true,
  },
  {
    route: "catalogues/plantProtection",
    id: "classifiers",
    translationId: "navbar.catalogues",
    dropdown: true,
  },
];

export default MENU_ITEMS;
